import type { ConfigType } from '@plone/registry';
import Footer from 'novareto-bg-etem/components/slots/Footer';
import PostFooter from 'novareto-bg-etem/components/slots/PostFooter';

export default function install(config: ConfigType) {
  config.unRegisterSlotComponent('footer', 'coreFooter', 0);
  config.unRegisterSlotComponent(
    'postFooter',
    'PostFooterFollowUsLogoAndLinks',
    0,
  );
  config.unRegisterSlotComponent('postFooter', 'Colophon', 0);

  config.registerSlotComponent({
    name: 'Footer',
    slot: 'footer',
    component: Footer,
  });

  config.registerSlotComponent({
    name: 'PostFooter',
    slot: 'postFooter',
    component: PostFooter,
  });

  return config;
}
